import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

export const SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_PAGE_SIZE = 25;

// Total number of pages for a result set (always at least 1).
export function pageCount(totalResults: number, pageSize: number): number {
  if (!pageSize || pageSize < 1) return 1;
  return Math.max(1, Math.ceil(totalResults / pageSize));
}

// Whether a page after the current one exists.
export function hasMorePages(currentPage: number, pageSize: number, totalResults: number): boolean {
  return currentPage * pageSize < totalResults;
}

// Whether the pagination controls should be shown (more than one page's worth).
export function shouldShowControls(totalResults: number, pageSize: number): boolean {
  return totalResults > pageSize;
}

// Resolve the backend row total (COUNT(*) OVER() on row 0), falling back to page length.
export function resolveTotal(rows: Array<{ Total?: any }> | null | undefined): number {
  if (!rows || rows.length === 0) return 0;
  return Number(rows[0]?.Total) || rows.length;
}

// Debounce + distinct pipeline for keystroke search: fire once the user stops
// typing for `ms`, and skip an unchanged query.
export function debouncedSearch<T>(source$: Observable<T>, ms: number = SEARCH_DEBOUNCE_MS): Observable<T> {
  return source$.pipe(debounceTime(ms), distinctUntilChanged());
}
